// src/utils/validators.ts
export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isValidZipCode = (zipCode: string): boolean => {
  return /^\d{5}(-\d{4})?$/.test(zipCode);
};

// Tax ID validation - supports both SSN (XXX-XX-XXXX) and EIN (XX-XXXXXXX) formats
export const isValidTaxId = (taxId: string): boolean => {
  // Remove any non-alphanumeric characters for validation
  const cleanTaxId = taxId.replace(/[^0-9]/g, '');
  
  // SSN must be 9 digits and not all the same digit
  const isValidSSN = cleanTaxId.length === 9 && !/^(\d)\1{8}$/.test(cleanTaxId);
  
  // EIN must be 9 digits and start with specific digits
  const isValidEIN = cleanTaxId.length === 9;
  
  return isValidSSN || isValidEIN;
};

// Phone/Fax validation - supports formats: (XXX) XXX-XXXX, XXX-XXX-XXXX, XXXXXXXXXX
export const isValidPhone = (phoneNumber: string): boolean => {
  if (!phoneNumber) return true; // Empty is considered valid (for optional fields)
  
  // Remove all non-numeric characters
  const cleanPhone = phoneNumber.replace(/[^0-9]/g, '');
  
  // Valid phone number should have 10 digits (US format)
  return cleanPhone.length === 10;
};

export const isValidDateOfBirth = (dateString: string): boolean => {
  if (!dateString) return false;
  
  const birthDate = new Date(dateString);
  const today = new Date();
  
  // Clear time portion for accurate date comparison
  today.setHours(0, 0, 0, 0);
  
  // Check that the date is valid and in the past
  if (isNaN(birthDate.getTime()) || birthDate >= today) {
    return false;
  }

  // Additional DOB-specific validations could be added here in the future
  // For example, minimum age requirements, reasonable date ranges, etc.
  
  return true;
};